import { render, staticRenderFns } from "./SelfServiceAuth.vue?vue&type=template&id=871a17c4&scoped=true&"
import script from "./SelfServiceAuth.vue?vue&type=script&lang=js&"
export * from "./SelfServiceAuth.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceAuth.vue?vue&type=style&index=0&id=871a17c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871a17c4",
  null
  
)

export default component.exports